var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx, jsxs as _jsxs } from "theme-ui/jsx-runtime";
import React from 'react';
import { space, layout, systemSxFromProps, } from '@revdotcom/vaporwave-system';
import { useTextField } from '@react-aria/textfield';
import { useId } from '@react-aria/utils';
import { getTextInputSx, getHelperTextSx, textInputContainerSx, getHelperTextIconSx, } from '@revdotcom/vaporwave-sx';
import { Label } from './Internal/Label';
import SvgSuccess from './Internal/Icons/SvgSuccess';
import SvgWarning from './Internal/Icons/SvgWarning';
import SvgError from './Internal/Icons/SvgError';
var VaporwaveTextInput = function (_a, ref) {
    var _b = _a.size, size = _b === void 0 ? 'small' : _b, labelColor = _a.labelColor, helperText = _a.helperText, _c = _a.helperTextType, helperTextType = _c === void 0 ? 'guidance' : _c, className = _a.className, onChangeHandler = _a.onChangeHandler, rest = __rest(_a, ["size", "labelColor", "helperText", "helperTextType", "className", "onChangeHandler"]);
    var fallbackRef = React.useRef(null);
    var DOMRef = ref !== null && ref !== void 0 ? ref : fallbackRef;
    var _d = useTextField(rest, DOMRef), labelProps = _d.labelProps, inputProps = _d.inputProps;
    var helperTextId = useId();
    if (helperText) {
        inputProps['aria-describedby'] = helperTextId;
    }
    // combine react-aria onChange and direct onChangeHandler, if at least one is provided
    var onChange = inputProps.onChange, restInputProps = __rest(inputProps, ["onChange"]);
    var onInputChange = onChangeHandler
        ? function (e) {
            onChange && onChange(e);
            onChangeHandler(e);
        }
        : onChange;
    var helperTextIcon, helperTextColor;
    switch (helperTextType) {
        case 'success':
            helperTextIcon = _jsx(SvgSuccess, {});
            helperTextColor = 'gray-70';
            break;
        case 'warning':
            helperTextIcon = _jsx(SvgWarning, {});
            helperTextColor = 'gray-70';
            break;
        case 'error':
            helperTextIcon = _jsx(SvgError, {});
            helperTextColor = 'error';
            break;
        case 'guidance':
            helperTextIcon = null;
            helperTextColor = 'gray-70';
            break;
    }
    return (_jsxs("div", { className: className, "data-testid": "textinput-container", sx: __assign(__assign({}, textInputContainerSx), systemSxFromProps(rest, __spreadArray(__spreadArray([], space, true), layout, true))), children: [rest.label && (_jsx(Label, __assign({}, labelProps, { color: labelColor, isRequired: rest.isRequired, children: rest.label }))), _jsx("input", __assign({}, restInputProps, { onChange: onInputChange, required: rest.required, ref: DOMRef, sx: getTextInputSx(size) })), helperText && (_jsxs("span", { id: helperTextId, sx: getHelperTextSx(helperTextColor, rest.validationState), children: [helperTextIcon && (_jsx("span", { sx: getHelperTextIconSx(), children: helperTextIcon })), helperText] }))] }));
};
/**
 * Renders a text input with the specified `label` prop.
 *
 * The vaporwave Checkbox component can be styled using the styled-system margin, padding, and width props.
 *
 * If the `label` prop isn't used, you must define the label for the input using `aria-label` or `aria-labelledby`.
 */
export var TextInput = React.forwardRef(VaporwaveTextInput);
